import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.ProfileModule.hooks.useNotifyAdmins', {
    notifyAdminSuccess: 'A notification has been sent to all administrators of the selected organisation.',
});
